module.exports = __webpack_public_path__ + "img/ico_jg2.b537743d.png";